import {BASIC_LOADING_STATUS} from "../../constants/store";

export const loading_status = (state = "", action) => {
  switch (action.type) {
    case BASIC_LOADING_STATUS:
      return action.payload;
    default:
      return state;
  }
};